// extracted by mini-css-extract-plugin
export default {"container":"Hj-z","bubbleNav":"Ij-z","graphic":"Jj-z","contact":"Kj-z"};